import React, { Component, Suspense } from 'react';

const SensibleWeather = React.lazy(() => import('./SensibleWeather'));

export default class SensibleWeatherWrapper extends Component {
  render() {
    return (
      <Suspense fallback={null}>
        <SensibleWeather
          selected={this.props.selected}
          coverageStartDate={this.props.coverageStartDate}
          coverageEndDate={this.props.coverageEndDate}
          currency={this.props.currency}
          exposureName={this.props.exposureName}
          exposureLatitude={this.props.exposureLatitude}
          exposureLongitude={this.props.exposureLongitude}
          exposureTotalCoverageAmount={this.props.exposureTotalCoverageAmount}
          langLocale={this.props.langLocale}
          onInsuranceChange={this.props.onInsuranceChange}
          isEligible={this.props.isEligible}
          eventId={this.props.eventId}
          coverageStartHourNumber={this.props.coverageStartHourNumber}
          coverageEndHourNumber={this.props.coverageEndHourNumber}
          sensibleExternalId={this.props.sensibleExternalId}
          productId={this.props.productId}
          partnerId={this.props.partnerId}
          sandbox={this.props.sandbox}
        />
      </Suspense>
    );
  }
}

SensibleWeatherWrapper.propTypes = {};
